import React, { useState, useContext } from "react";
import { useField } from "formik";
import { Dropdown } from "react-bootstrap";
import { MdGroups, MdChevronLeft, MdPlace } from "react-icons/md";
import { VscChevronDown } from "react-icons/vsc";
import FieldError from "../../shared/FieldError";
import { Settings } from "../../helpers/Contexts";
import DropdownMenu from "../../shared/DropdownMenu";

const SelectPcp = ({ active, setFieldValue, pcpRequired, required, ...props }) => {
  const settings = useContext(Settings) || props.settings;
  const [pcpGroups, setPcpGroups] = useState([]);
  let [valueLabel, setValueLabel] = useState(props.valueLabel);
  let position = props.position;
  React.useEffect(() => {
    setPcpGroups(settings.pcps_by_practice);
  }, [settings.pcps_by_practice]);
  const [field, meta, helpers] = useField(props);
  const [activeList, setActiveList] = useState({
    group: "",
    practices: [],
    practice: "",
    pcps: [],
  });
  const [show, setShow] = useState(false);

  const Toggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        onClick(e);
        e.preventDefault();
        !show ? setShow(true) : setShow(false);
      }}
    >
      {children}
    </div>
  ));

  let filteredPcps = activeList.pcps.filter((el) => {
    if (el.active == false && el.electable_pcp == true) {
      return true;
    } else {
      return el.active == true;
    }
  });

  var dropDownClassNames = position ? `${ position } pcp-dropdown no-padding border` : 'pcp-dropdown no-padding border'
  return (
    <>
      <Dropdown show={show} className="dropdown-select">
        <Dropdown.Toggle as={Toggle}>
          {field.value && (<>{valueLabel ? valueLabel : field.value } </>) || ("Select Provider")}
          <VscChevronDown className="chevron-icon" />
        </Dropdown.Toggle>
        <Dropdown.Menu as={DropdownMenu} className={dropDownClassNames}>
          {pcpGroups && !activeList.group && (
            <>
              <Dropdown.Header>PCP Groups</Dropdown.Header>
              {pcpGroups.map((group, i) => (
                <Dropdown.Item
                  key={i}
                  as={"li"}
                  onClick={() => {
                    setActiveList({
                      ...activeList,
                      group: group.name,
                      practices: group.pcp_practices,
                    });
                  }}
                >
                  <MdGroups className="group-icon dropdown" />
                  {group.name}
                </Dropdown.Item>
              ))}
            </>
          )}

          {activeList.group && !activeList.practice && (
            <>
              <Dropdown.Header
                id="menu-item"
                onClick={() => {
                  setActiveList({ group: "", practices: [], practice: "", pcps: [] });
                }}
              >
                <MdChevronLeft className="left-icon" />
                <MdGroups className="group-icon dropdown" />
                {activeList.group}
              </Dropdown.Header>{" "}
              <Dropdown.Header>{"Locations"}</Dropdown.Header>
              {activeList.practices.map((practice, i) => (
                <Dropdown.Item
                  key={i}
                  as={"li"}
                  onClick={() => {
                    setActiveList({
                      ...activeList,
                      practice: { ...practice },
                      pcps: practice.pcps,
                    });
                  }}
                >
                  <MdPlace className="pcp-icon" />
                  {practice.name}
                </Dropdown.Item>
              ))}
            </>
          )}

          {activeList.practice.name && (
            <>
              <Dropdown.Header
                id="menu-item"
                onClick={() => {
                  setActiveList({ ...activeList, practice: "", pcps: [] });
                }}
              >
                <MdChevronLeft className="left-icon" />
                <MdPlace className="pcp-icon" /> {activeList.practice.name}
              </Dropdown.Header>{" "}
              { pcpRequired != true && (
                <Dropdown.Item
                  as={"li"}
                  onClick={() => {
                    setShow(false);
                    setFieldValue("pcp_practice_id", activeList.practice.id);
                    setFieldValue("pcp", "Any available PCP");
                    setFieldValue("pcp_practice_name", activeList.practice.name);
                    setFieldValue("pcp_practice_address", activeList.practice.address);
                    setFieldValue("pcp_id", "");
                  }}
                >
                  Any Available PCP
                </Dropdown.Item>
              )}
              <Dropdown.Header>Providers</Dropdown.Header>
              {filteredPcps.map((p, i) => (
                <Dropdown.Item
                  key={i}
                  as={"li"}
                  onClick={() => {
                    setShow(false);
                    setFieldValue("pcp_practice_id", activeList.practice.id);
                    setFieldValue("pcp_practice_name", activeList.practice.name);
                    setFieldValue("pcp_practice_address", activeList.practice.address);
                    setFieldValue("pcp_id", p.id);
                    setFieldValue("provider", p.name);
                    setFieldValue("pcp", p.name);
                    if (props.name && props.name.match(/id/i)) {
                      setFieldValue(props.name, p.id);
                      setValueLabel(p.name);
                    }
                  }}
                >
                  {p.name}
                </Dropdown.Item>
              ))}{" "}
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {meta.touched && meta.error ? <FieldError error={meta.error} /> : null}
    </>
  );
};

export default SelectPcp;
